import React from 'react';

type ErrorTypes = string | object | null;

interface ErrorProps {
  error: ErrorTypes;
  style?: React.CSSProperties;
}

function showError(error: ErrorTypes) {
  if (typeof error === 'object') {
    return JSON.stringify(error);
  }
  return error.length ? error : null;
}

export default function Error({ error, style }: ErrorProps) {
  return error ? (
    <div>
      <h2 style={{ ...style }}>{showError(error)}</h2>
    </div>
  ) : null;
}